import type { ConceptDef } from '../types';

export const intraverbalNameCategory: ConceptDef = {
  kind: 'tileMatch',
  id: 'intraverbal-name-category',
  label: 'Intraverbal Name-A-Category',
  category: 'Intraverbal',
  description: 'Hear a category prompt; tap an example.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'Name an animal.', answer: '🐶 dog' },
      { say: 'Name a fruit.', answer: '🍎 apple' },
      { say: 'Name a vehicle.', answer: '🚗 car' },
      { say: 'Name a tool.', answer: '🔨 hammer' },
      { say: 'Name a piece of clothing.', answer: '👕 shirt' },
      { say: 'Name a drink.', answer: '🥛 milk' },
    ],
  },
};
